/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const MANAGE_LOCATIONS = 'Manage Sub-Realms';
export const CLOSE = 'Close';
export const ADD = 'Add';
export const ALL = 'All';
export const NO_OPTIONS = 'No options';
export const DELETE = 'Delete';
export const CANCEL_BTN_TEXT = 'Cancel';
export const SAVE = 'Save';
export const DROPDOWN_MAX_HEIGHT = 350;
export const ADD_RESTRICTION = 'You can select up to {0} sub-realms at a time. To add more than {1} sub-realms, please save and reopen the modal to add more.';
export const REMOVE_RESTRICTION = 'You can deselect up to {0} sub-realms at a time. To remove more than {1} sub-realms, please save and reopen the modal to remove more.';
export const LOCATIONS_CHANGED = 'Sub-Realms are changed';

export const MAX_PAGE_SIZE = 2 ** 31 - 2;
